import axios from './index';

import type { ResType } from '@/typings/common';

/**
 * Types
 */

/** 注册渠道（GET /v1/registration-channels） */
export type RegistrationChannelItem = {
    id: string;
    name: string;
    code: string;
    user_count: number;
    created_at: string;
};

/**
 * APIs
 */

/** 注册渠道列表（含各渠道注册用户数） */
export const registrationChannelListApi = () => {
    return axios<ResType<RegistrationChannelItem[]>>('/v1/registration-channels', {
        method: 'get',
    });
};
